// extracted by mini-css-extract-plugin
export default {"footerInformationContainer":"footer-information_footerInformationContainer__9Pyg5"};